import { useState, useEffect } from 'react';
import HomeItem from './components/HomeItem';
import fetchRecipeInfo from './utils/fetchRecipeInfo';
import getAllRecipes from './utils/getAllRecipes';
import './scss/Home.scss';

function Home() {

  const [homeData, setHomeData] = useState([])
  
  const ids = [
    'chili-garlic-spicy-noodles',
    'detroit-style-pizza',
    'samoas-cookies',
    'chicken-satay-lettuce-wraps',
    'lavash-triangles',
    'pasta-amatriciana',
    'dak-galbi',
    'eggplant-parmesan',
    'springtime-saffron-pasta',
  ]

  useEffect(() => {
    setHomeData(fetchRecipeInfo(ids));
    getAllRecipes();
  }, [])

  return(
    <div id="home">
      <div className="grid">
        <div className="homeIntro">
          <p>A small collection of recipes from some of the most beloved restaurants in the Lower East Side of New York City.</p>
          <button>Read more</button>
        </div>
        {homeData.map((item, index) => 
          <HomeItem item={item} key={index} />
        )}
      </div>
    </div>
  )
}

export default Home;